import { useState, useEffect, useContext } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { DealService, Deal, DealRequest, LifecycleStage } from "./deal.service";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import {
  accountType,
  documentType,
  LocaleData,
  statusList,
} from "../../../core/common/selectoption/selectoption";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import male from "../../../../src/assets/male.png";
import axios from "axios";
import { API_BASE_URL } from "../../../environment";
import { getAuthHeaders } from "../../../utils/authUtils";
import { AuthContext } from "../../../context/authcontext";
import DealForm from "./dealForm";
import { useDealFormData, DealFormDataProvider } from "./dealFormDataContext";
import { getLifecycleTypeName } from "../../../utils/lifecycleUtils";
import company from "../../../../src/assets/company.png";
import { formatCustomDateTime } from "../../../utils/dateUtils";
import { transformLookupDealToDeal } from "../utils/lookupTransforms";
import {
  showSuccessAlert,
  showErrorAlert,
} from "../../uiInterface/base-ui/alertservice";
import Activities from "../../../components/Tabs/Activities";
import Notes from "../../../components/Tabs/Notes";
import Files from "../../../components/Tabs/Files";
import Tasks from "../../../components/Tabs/Tasks";
import Email from "../../../components/Tabs/Email";
import ProductsServices from "../../../components/Tabs/ProductsServices";
import Chat from "../../../components/Tabs/Chat";
import Tabs from "../../../components/Tabs/tabs";
import { FaUsers } from "react-icons/fa";
import { useTenantChange } from "../../../hooks/useTenantChange";
import { getStageColorByOrder } from "../../../utils/stageColors";
import { useEmailProviders } from "../../../hooks/useEmailProviders";
import ComposeEmail from "../../application/components/email/ComposeEmail";
import ProposalForm from "../proposals/proposalForm";
import { ProposalFormDataProvider } from "../proposals/proposalFormDataContext";
import {
  ProposalService,
  ProposalRequest,
} from "../proposals/proposal.service";
import CustomFieldDisplay from "../../../components/CustomFieldDisplay";
import Tooltip from "@mui/material/Tooltip";
import MarkStatusModal from "./MarkStatusModal";
import SalesActivityModal from "../salesActivity/SalesActivityModal";
import { getApiErrorMessage } from "../../../utils/apiErrorUtils";

interface DealDetailsContentProps {
  isEditDealOpen: boolean;
  setIsEditDealOpen: (value: boolean) => void;
}

const DealDetailsContent = ({ isEditDealOpen, setIsEditDealOpen }: DealDetailsContentProps) => {
  const route = all_routes;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedTenantId, auth } = useContext(AuthContext);
  const { lifecycleStages: contextLifecycleStages } = useDealFormData();
  const [deal, setDeal] = useState<Deal | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lifecycleStages, setLifecycleStages] = useState<LifecycleStage[]>([]);
  const [stagesLoading, setStagesLoading] = useState(true);

  const [updatingStage, setUpdatingStage] = useState(false);
  const [updatingPriority, setUpdatingPriority] = useState(false);
  const [updateMessage, setUpdateMessage] = useState<string | null>(null);

  const [addcomment, setAddComment] = useState(false);
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [openModal, setOpenModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [editError, setEditError] = useState<string>("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string>("");
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [activitiesRefreshTrigger, setActivitiesRefreshTrigger] = useState(0);

  const { hasConnectedProviders, loading: emailProvidersLoading } =
    useEmailProviders();
  const [isComposeEmailOpen, setIsComposeEmailOpen] = useState(false);
  const [composeOpenCounter, setComposeOpenCounter] = useState(0);

  const [isCreatingProposal, setIsCreatingProposal] = useState(false);
  const [createProposalError, setCreateProposalError] = useState<string>("");
  const [resetProposalFormTrigger, setResetProposalFormTrigger] = useState(0);
  const [isCreateProposalOpen, setIsCreateProposalOpen] = useState(false);

  const [showMarkStatusModal, setShowMarkStatusModal] = useState(false);
  const [showSalesActivityModal, setShowSalesActivityModal] = useState(false);

  const handleMarkStatusSuccess = async () => {
    if (!deal?.deal_id || !selectedTenantId) return;
    try {
      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${deal.deal_id}&tenant_id=${selectedTenantId}`,
        { headers: getAuthHeaders() }
      );
      setDeal(transformLookupDealToDeal(refreshResponse.data));
    } catch (error) {
      console.error("Failed to refresh deal after status mark", error);
    }
  };

  const clearDealData = () => {
    setDeal(null);
    setError(null);
    setLoading(true);
  };

  useTenantChange({
    onTenantChange: () => {
      clearDealData();
      navigate("/deals");
    },
    clearData: clearDealData,
  });

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};

    for (let i = 0; i < 10; i++) {
      starsState[i] = false;
    }
    setStars(starsState);
  };

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };

  const createCompanyUrl = (deal: any): string => {
    if (!deal.company?.company_id) return "#";
    return `/companies/${deal.company.company_id}`;
  };
  const createContactUrl = (deal: any): string => {
    if (!deal.primary_contact?.contact_id) return "#";
    return `/contacts/${deal.primary_contact.contact_id}`;
  };

  const createLeadUrl = (deal: any): string => {
    if (!deal.realted_lead?.lead_id) return "#";
    return `/leads/${deal.realted_lead.lead_id}`;
  };

  const createPipelineUrl = (deal: any): string => {
    if (!deal.related_pipeline?.pipeline_id) return "#";
    return `/pipelines/${deal.related_pipeline.pipeline_id}`;
  };

  const handleStageUpdate = async (stageId: number | null) => {
    if (!deal?.deal_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/deal/${deal.deal_id}/`,
        {
          lifecycle_type_stage_id: stageId,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );
      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${deal.deal_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedDealData = refreshResponse.data;
      const transformedDeal = transformLookupDealToDeal(updatedDealData);

      setDeal(transformedDeal);
      setUpdateMessage("Deal stage updated successfully!");
      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error updating deal stage:", error);
      setUpdateMessage("Failed to update deal stage");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };
  const handlePriorityUpdate = async (priority: string) => {
    if (!deal?.deal_id || !selectedTenantId) return;

    setUpdatingPriority(true);
    setUpdateMessage(null);

    try {
      const response = await DealService.updateDealPriority(
        deal.deal_id,
        priority,
        Number(selectedTenantId)
      );
      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${deal.deal_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedDealData = refreshResponse.data;
      const transformedDeal = transformLookupDealToDeal(updatedDealData);

      setDeal(transformedDeal);
      setUpdateMessage("Deal priority updated successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error updating deal priority:", error);
      setUpdateMessage("Failed to update deal priority");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingPriority(false);
    }
  };
  const handleDeleteDeal = async () => {
    if (!deal?.deal_id || isDeleting || !selectedTenantId) return;

    setIsDeleting(true);
    setDeleteError("");

    try {
      await DealService.deleteDeal(deal.deal_id, Number(selectedTenantId));
      setOpenModal(false);
      setShowDeleteLoader(true);
      setTimeout(() => {
        setShowDeleteLoader(false);
        navigate(route.deals);
      }, 1500);
    } catch (error: any) {
      console.error("Error deleting deal:", error);
      setDeleteError(
        error.response?.data?.message ||
        "Failed to delete deal. Please try again."
      );
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteError("");
    setOpenModal(false);
  };

  const handleMarkAsActive = async () => {
    if (!deal?.deal_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/deal/${deal.deal_id}/`,
        {
          is_archive: false,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${deal.deal_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedDealData = refreshResponse.data;
      const transformedDeal = transformLookupDealToDeal(updatedDealData);

      setDeal(transformedDeal);
      setUpdateMessage("Deal marked as active successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error marking deal as active:", error);
      setUpdateMessage("Failed to mark deal as active");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleMarkAsArchive = async () => {
    if (!deal?.deal_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/deal/${deal.deal_id}/`,
        {
          is_archive: true,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${deal.deal_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedDealData = refreshResponse.data;
      const transformedDeal = transformLookupDealToDeal(updatedDealData);

      setDeal(transformedDeal);
      setUpdateMessage("Deal marked as archived successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error marking deal as archived:", error);
      setUpdateMessage("Failed to mark deal as archived");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleSendEmail = () => {
    setComposeOpenCounter((prev) => prev + 1);
    setIsComposeEmailOpen(true);
  };

  const handleCloseComposeEmail = () => {
    setIsComposeEmailOpen(false);
  };

  const handleMinimizeComposeEmail = () => {
    setIsComposeEmailOpen(false);
  };

  const handleCloseCreateProposal = () => {
    setCreateProposalError("");
    closeOffcanvas("offcanvas_create_proposal");
  };

  const handleCreateProposalSubmit = async (
    formData: Partial<ProposalRequest>
  ) => {
    setIsCreatingProposal(true);
    setCreateProposalError("");

    try {
      const createdProposal = await ProposalService.createProposal(formData as any);

      setTimeout(() => {
        closeOffcanvas("offcanvas_create_proposal");
        setResetProposalFormTrigger((prev) => prev + 1);
        showSuccessAlert(
          `${getLifecycleTypeName("PROPOSAL")} "${createdProposal.subject}" created successfully!`
        );
      }, 100);

      setTimeout(() => {
        navigate(`/proposals/${createdProposal.proposal_id}`);
      }, 1000);

      return createdProposal;
    } catch (error: any) {
      console.error("Error creating proposal:", error);
      setCreateProposalError(getApiErrorMessage(error, `Failed to create ${getLifecycleTypeName("PROPOSAL").toLowerCase()}. Please try again.`));
      showErrorAlert(getApiErrorMessage(error, `Failed to create ${getLifecycleTypeName("PROPOSAL").toLowerCase()}. Please try again.`));
      throw error;
    } finally {
      setIsCreatingProposal(false);
    }
  };

  const getPrefilledProposalData = () => {
    if (!deal) return {};

    const prefilledProductsServices = deal.product_n_service ?
      deal.product_n_service.map((item: any, index: number) => ({
        id: index + 1,
        product_n_service_id: item.product_n_service_id,
        product_n_service_name: item.product_n_service_name,
        product_n_service_unit_price: item.product_n_service_unit_price,
        quantity: item.quantity || 1,
        discount_percentage: item.discount_percentage || 0,
        gross_total: item.gross_total || 0,
        discounted_total: item.discounted_total || 0,
        currency_code: item.currency_code || deal.currency_code,
        isExisting: false,
        service_tax_percentage: item.service_tax_percentage || 0,
        gst_tax_percentage: item.gst_tax_percentage || 0,
        vat_tax_percentage: item.vat_tax_percentage || 0,
        service_tax_total: item.service_tax_total || 0,
        gst_tax_total: item.gst_tax_total || 0,
        vat_tax_total: item.vat_tax_total || 0,
      })) : [];

    return {
      subject: deal.title || "",
      description: `${getLifecycleTypeName("PROPOSAL")} for ${deal.title || getLifecycleTypeName("DEAL")}`,
      amount: deal.estimated_value || undefined,
      currency_code: deal.currency_code || "USD",
      company_id: deal.company?.company_id || null,
      company: deal.company || null,
      primary_contact_id: deal.primary_contact?.contact_id || null,
      contact: deal.primary_contact || null,
      deal_id: deal.deal_id || null,
      product_n_services: deal.products_n_services || "",
      assigned_user_id: deal.assigned_user?.user_id || null,
      assigned_team_id: deal.assigned_team?.team_id || null,
      prefilled_products_services: prefilledProductsServices,
      custom_fields: (deal as any).custom_fields || [],
    };
  };

  const getPrimaryEmail = () => {
    if (deal?.primary_contact?.primary_email) {
      return deal.primary_contact.primary_email;
    }
    return "";
  };

  const isEmailEnabled =
    !emailProvidersLoading && hasConnectedProviders && getPrimaryEmail() !== "";

  const getEmailDisabledReason = () => {
    if (emailProvidersLoading) return "Checking email integration...";
    if (!hasConnectedProviders) return "Email is not integrated";
    if (!deal?.primary_contact) return "No contact attached to this deal";
    if (!getPrimaryEmail()) return "Attached contact has no email address";
    return "Email is not available";
  };

  const handleRefreshData = async () => {
    if (!id || !selectedTenantId) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const dealData = response.data;
      const transformedDeal = transformLookupDealToDeal(dealData);

      setDeal(transformedDeal);
      setActivitiesRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("Error refreshing deal data:", error);
    }
  };

  const handleEditSubmit = async (formData: Partial<DealRequest>) => {
    if (!deal?.deal_id || isUpdating) return;

    setIsUpdating(true);
    setEditError("");

    try {
      const updatedDeal = await DealService.updateDeal(
        deal.deal_id,
        formData as any
      );
      setDeal(updatedDeal);
      setActivitiesRefreshTrigger((prev) => prev + 1);
      closeOffcanvas("offcanvas_edit_deal");

      setTimeout(() => {
        showSuccessAlert(`Deal "${updatedDeal.title}" updated successfully!`);
      }, 500);
    } catch (error: any) {
      console.error("Error updating deal:", error);
      setEditError(getApiErrorMessage(error, "Failed to update deal. Please try again."));
      showErrorAlert(getApiErrorMessage(error, "Failed to update deal. Please try again."));
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };
  const closeOffcanvas = (offcanvasId: string) => {
    const modal = document.getElementById(offcanvasId);
    if (modal) {
      const closeButton = modal.querySelector(
        '[data-bs-dismiss="offcanvas"]'
      ) as HTMLElement;
      if (closeButton) {
        closeButton.click();
      } else {
        try {
          if ((window as any).bootstrap?.Offcanvas) {
            const bsOffcanvas = (window as any).bootstrap.Offcanvas.getInstance(
              modal
            );
            if (bsOffcanvas) {
              bsOffcanvas.hide();
            } else {
              const newOffcanvas = new (window as any).bootstrap.Offcanvas(
                modal
              );
              newOffcanvas.hide();
            }
          } else {
            throw new Error("Bootstrap not available");
          }
        } catch (error) {
          console.warn(
            "Failed to close offcanvas via Bootstrap, using manual approach"
          );
          modal.classList.remove("show");
          modal.setAttribute("aria-hidden", "true");
          document.body.classList.remove("offcanvas-open");
          document.body.style.overflow = "";
          document.body.style.paddingRight = "";
          const backdrops = document.querySelectorAll(".offcanvas-backdrop");
          backdrops.forEach((backdrop) => backdrop.remove());
        }
      }
    }
  };
  const DeletePreloader = () => {
    return (
      <div
        className="preloader"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div className="loader"></div>
        <p className="mt-3 text-muted">
          Deal deleted successfully. Redirecting...
        </p>
      </div>
    );
  };

  const sortbydata = [
    { value: "Sort By Date", label: "Sort By Date" },
    { value: "Ascending", label: "Ascending" },
    { value: "Descending", label: "Descending" },
  ];

  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];

  const priorityOptions = [
    {
      value: "High",
      label: "High",
      icon: (
        <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
      ),
    },
    {
      value: "Medium",
      label: "Medium",
      icon: (
        <i className="ti ti-square-rounded-filled me-1 text-secondary circle" />
      ),
    },
    {
      value: "Low",
      label: "Low",
      icon: <i className="ti ti-square-rounded-filled me-1 text-info circle" />,
    },
  ];

  const status = [
    { value: "choose", label: "Choose" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "pending", label: "Pending" },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
  ];

  useEffect(() => {
    initializeStarsState();
  }, []);

  useEffect(() => {
    const editOffcanvas = document.getElementById("offcanvas_edit_deal");

    const handleHidden = () => {
      setIsEditDealOpen(false);
    };

    if (editOffcanvas) {
      editOffcanvas.addEventListener("hidden.bs.offcanvas", handleHidden);
    }

    return () => {
      if (editOffcanvas) {
        editOffcanvas.removeEventListener("hidden.bs.offcanvas", handleHidden);
      }
    };
  }, []);

  useEffect(() => {
    const createProposalOffcanvas = document.getElementById(
      "offcanvas_create_proposal"
    );

    const handleHidden = () => {
      setIsCreateProposalOpen(false);
    };

    if (createProposalOffcanvas) {
      createProposalOffcanvas.addEventListener(
        "hidden.bs.offcanvas",
        handleHidden
      );
    }

    return () => {
      if (createProposalOffcanvas) {
        createProposalOffcanvas.removeEventListener(
          "hidden.bs.offcanvas",
          handleHidden
        );
      }
    };
  }, []);

  useEffect(() => {
    const fetchDeal = async () => {
      if (!id || !selectedTenantId) {
        setError("Deal ID or tenant ID not provided");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setStagesLoading(true);

        const response = await axios.get(
          `${API_BASE_URL}/lookup/deal/?deal_id=${id}&tenant_id=${selectedTenantId}`,
          {
            headers: getAuthHeaders(),
          }
        );

        const dealData = response.data;
        const transformedDeal = transformLookupDealToDeal(dealData);

        setDeal(transformedDeal);
        if (
          dealData.lifecycle_type_stage &&
          Array.isArray(dealData.lifecycle_type_stage)
        ) {
          const sortedStages = dealData.lifecycle_type_stage.sort(
            (a: any, b: any) => a.stage_order - b.stage_order
          );
          setLifecycleStages(sortedStages);
        }

        setStagesLoading(false);
        setLoading(false);
      } catch (err: any) {
        console.error("Error fetching deal details:", err);

        if (err?.response?.status === 404) {
          navigate(route.deals);
          return;
        }

        setError("Failed to fetch deal details");
        setLoading(false);
        setStagesLoading(false);
      }
    };

    fetchDeal();
  }, [id, selectedTenantId]);

  const refreshDealData = async () => {
    const dealId = id || deal?.deal_id;
    if (!dealId || !selectedTenantId) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/lookup/deal/?deal_id=${dealId}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const dealData = response.data;
      const transformedDeal = transformLookupDealToDeal(dealData);

      setDeal(transformedDeal);
    } catch (err: any) {
      console.error("Error refreshing deal details:", err);
    }
  };
  useEffect(() => {
    if (contextLifecycleStages.length > 0 && lifecycleStages.length === 0) {
      setLifecycleStages(contextLifecycleStages);
      setStagesLoading(false);
    }
  }, [contextLifecycleStages, lifecycleStages]);

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {" "}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("DEAL")} Overview
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="text-center">
                      <div
                        className="spinner-border text-primary mb-3"
                        role="status"
                        style={{ width: "3rem", height: "3rem" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <h5 className="text-muted">
                        Loading {getLifecycleTypeName("DEAL")} details...
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !deal) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-danger" role="alert">
                <h5 className="alert-heading">Error</h5>
                <p className="mb-0">{error || "Deal not found"}</p>
                <hr />
                <Link to={route.deals} className="btn btn-outline-danger">
                  <i className="ti ti-arrow-narrow-left me-1" />
                  Back to Deals
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isStageActive = (stageId: number): boolean => {
    if (!deal.lifecycle_type_stage?.lifecycle_type_stage_id) return false;

    const currentStageId = deal.lifecycle_type_stage.lifecycle_type_stage_id;
    const currentStage = lifecycleStages.find(
      (stage) => stage.lifecycle_type_stage_id === currentStageId
    );
    const checkStage = lifecycleStages.find(
      (stage) => stage.lifecycle_type_stage_id === stageId
    );

    if (!currentStage || !checkStage) return false;

    return checkStage.stage_order <= currentStage.stage_order;
  };

  return (
    <>
      {/* Show delete loader overlay */}
      {showDeleteLoader && <DeletePreloader />}

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {" "}
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("DEAL")} Overview
                    </h4>
                  </div>
                  <div className="col-sm-8 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* Success/Error Message */}
              {updateMessage && (
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className={`alert ${updateMessage.includes("successfully")
                        ? "alert-success"
                        : "alert-danger"
                        } alert-dismissible fade show`}
                      role="alert"
                    >
                      {updateMessage}
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setUpdateMessage(null)}
                      ></button>
                    </div>
                  </div>
                </div>
              )}
              {/* /Page Header */}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {/* Deal User */}
              <div className="contact-head">
                <div className="row align-items-center">
                  <div className="col-sm-6">
                    {" "}
                    <ul className="contact-breadcrumb">
                      <li>
                        <Link to={route.deals}>
                          <i className="ti ti-arrow-narrow-left" />
                          {getLifecycleTypeName("DEAL")}
                        </Link>
                      </li>
                      <li>{deal.title && deal.title.length > 80 ? (
                        <Tooltip title={deal.title} placement="top" arrow>
                          <p className="mb-1" style={{ cursor: "default" }}>
                            {`${deal.title.substring(0, 80)}...`}
                          </p>
                        </Tooltip>
                      ) : (
                        <p className="mb-1">{deal.title}</p>
                      )}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card" style={{ position: 'relative' }}>
                {deal.is_archive && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '150px',
                      height: '150px',
                      overflow: 'hidden',
                      zIndex: 10,
                      pointerEvents: 'none',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '20px',
                        left: '-53px',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        padding: '8px 40px',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        transform: 'rotate(-45deg)',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                        textAlign: 'center',
                        width: '150px',
                      }}
                    >
                      Archived
                    </div>
                  </div>
                )}
                <div className="card-body pb-2">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center mb-2">
                      <div
                        className="avatar avatar-xl me-3 flex-shrink-0 border p-2 bg-light"
                        style={{ borderRadius: "50%" }}
                      >
                        <i
                          className="ti ti-medal"
                          style={{ color: "#824eeb", fontSize: "3rem" }}
                        />
                      </div>
                      <div>
                        <div className="d-flex align-items-center flex-wrap gap-2">
                          {deal.title && deal.title.length > 20 ? (
                            <Tooltip title={deal.title} placement="top" arrow>
                              <h3 className="mb-1" style={{ cursor: "default" }}>
                                {`${deal.title.substring(0, 20)}...`}
                              </h3>
                            </Tooltip>
                          ) : (
                            <h3 className="mb-1">{deal.title}</h3>
                          )}
                          {deal.lifecycle_status_reason && (
                            <Tooltip title={deal.lifecycle_status_reason.reason_name} placement="top" arrow>
                              <span
                                className={`badge d-inline-flex align-items-center mb-1 ${deal.lifecycle_status_reason.lifecycle_status_reason_category_key === "WON" ? "bg-success" : "bg-secondary"}`}
                                style={{ cursor: "default" }}
                              >
                                <i className={`fa ${deal.lifecycle_status_reason.lifecycle_status_reason_category_key === "WON" ? "fa-trophy" : "fa-thumbs-down"} me-1`} />
                                {deal.lifecycle_status_reason.lifecycle_status_reason_category_key === "WON" ? "Won" : "Lost"}
                              </span>
                            </Tooltip>
                          )}
                        </div>
                        <p className="mb-1">
                          <i className="ti ti-building me-1" />
                          {deal.company?.company_name || "No Company"}
                        </p>
                      </div>
                    </div>
                    <div className="contacts-action">
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        <div className="mb-2">
                          <Select
                            options={lifecycleStages.map((stage) => ({
                              value: stage.lifecycle_type_stage_id,
                              label: stage.stage_name,
                            }))}
                            value={
                              lifecycleStages.find(
                                (stage) =>
                                  stage.lifecycle_type_stage_id ===
                                  deal.lifecycle_type_stage
                                    ?.lifecycle_type_stage_id
                              )
                                ? {
                                  value:
                                    deal.lifecycle_type_stage
                                      ?.lifecycle_type_stage_id,
                                  label:
                                    deal.lifecycle_type_stage?.stage_name,
                                }
                                : null
                            }
                            onChange={(option) =>
                              handleStageUpdate(option?.value || null)
                            }
                            placeholder="Select stage"
                            isClearable={false}
                            isLoading={updatingStage}
                            isDisabled={updatingStage}
                            className="min-w-200"
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minWidth: "200px",
                                backgroundColor: "#28a745",
                                borderColor: "#28a745",
                                color: "white",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                color: "white",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: "rgba(255, 255, 255, 0.8)",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                        {isEmailEnabled ? (
                          <button
                            className="btn btn-secondary d-flex align-items-center mb-2"
                            onClick={handleSendEmail}
                            title="Send Email"
                          >
                            <i className="ti ti-mail me-2" />
                            Send Email
                          </button>
                        ) : (
                          <Tooltip title={getEmailDisabledReason()} placement="top" arrow>
                            <span
                              className="btn btn-secondary d-flex align-items-center mb-2"
                              style={{ cursor: "not-allowed", opacity: 0.5 }}
                            >
                              <i className="ti ti-mail me-2" />
                              Send Email
                            </span>
                          </Tooltip>
                        )}

                        <button
                          className="btn btn-primary d-flex align-items-center mb-2"
                          title={`Create ${getLifecycleTypeName("PROPOSAL")}`}
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_create_proposal"
                          onClick={() => setIsCreateProposalOpen(true)}
                        >
                          <i className="ti ti-file-text me-2" />
                          Create {getLifecycleTypeName("PROPOSAL")}
                        </button>

                        <Link
                          to="#"
                          className="btn-icon d-flex align-items-center justify-content-center mb-2"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_edit_deal"
                          title="Edit Deal"
                          onClick={() => setIsEditDealOpen(true)}
                        >
                          <i className="ti ti-edit-circle fs-16" />
                        </Link>
                        <Link
                          className="btn-icon d-flex align-items-center justify-content-center mb-2"
                          to="#"
                          onClick={(e) => { e.preventDefault(); setShowSalesActivityModal(true); }}
                          title="Log Activity"
                        >
                          <i className="ti ti-clipboard-list fs-16" />
                        </Link>
                        <div className="dropdown">
                          <Link
                            to="#"
                            className="btn-icon d-flex align-items-center justify-content-center mb-2"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            title="More Actions"
                          >
                            <i className="ti ti-dots-vertical fs-16" />
                          </Link>{" "}
                          <div className="dropdown-menu dropdown-menu-end dropup" style={{ minWidth: "220px" }}>
                            {deal.is_archive ? (
                              <Link
                                className="dropdown-item d-flex align-items-center"
                                to="#"
                                onClick={() => handleMarkAsActive()}
                              >
                                <i className="ti ti-check text-success me-2" />
                                Mark as Active
                              </Link>
                            ) : (
                              <Link
                                className="dropdown-item d-flex align-items-center"
                                to="#"
                                onClick={() => handleMarkAsArchive()}
                              >
                                <i className="ti ti-archive-off text-warning me-2" />
                                Mark as Archive
                              </Link>
                            )}
                            <Link
                              className="dropdown-item d-flex align-items-center"
                              to="#"
                              onClick={(e) => { e.preventDefault(); setShowMarkStatusModal(true); }}
                            >
                              <i className="ti ti-trophy text-info me-2" />
                              Mark as Lost/Won
                            </Link>

                            <Link
                              className="dropdown-item d-flex align-items-center"
                              to="#"
                              onClick={() => setOpenModal(true)}
                            >
                              <i className="ti ti-trash text-danger me-2" />
                              Delete
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Deal User */}
            </div>
            {/* Deal Sidebar */}
            <div className="col-xl-3 theiaStickySidebar">
              <div className="card">
                <div className="card-body p-3">
                  <h6 className="mb-3 fw-semibold">
                    {getLifecycleTypeName("DEAL")} Information
                  </h6>
                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">Estimated Value</span>
                      <span className="col-6">
                        {(deal.grand_total ?? deal.estimated_value)
                          ? `${deal.currency_code || ""
                          } ${Number(deal.grand_total ?? deal.estimated_value ?? 0).toFixed(4)}`
                          : "Not specified"}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Source</span>
                      <span className="col-6">
                        {deal.realted_lead?.lifecycle_source?.lifecycle_source_display_name ||
                          deal.lifecycle_source?.lifecycle_source_display_name ||
                          (deal as any)?.source ||
                          "Not specified"}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Lifecycle Stage</span>
                      <span className="col-6">
                        <span
                          className={`badge ${getStageColorByOrder(
                            lifecycleStages.find(
                              (stage) =>
                                stage.lifecycle_type_stage_id ===
                                deal.lifecycle_type_stage
                                  ?.lifecycle_type_stage_id
                            )?.stage_order || 1
                          )}`}
                        >
                          {deal.lifecycle_type_stage?.stage_name || "Not Set"}
                        </span>
                      </span>
                    </li>
                  </ul>
                  <CustomFieldDisplay
                    customFields={(deal as any)?.custom_fields}
                    showTitle={true}
                  />
                  <h6 className="mb-3 fw-semibold">Assigned Team</h6>
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="avatar avatar-md me-2 d-flex align-items-center justify-content-center bg-light"
                      style={{ width: 40, height: 40, borderRadius: "50%" }}
                    >
                      <i className="ti ti-users fs-24 text-primary" />
                    </div>
                    <div>
                      <div className="d-flex align-items-center gap-2">
                        {/* <FaUsers className="me-1 text-primary" /> */}
                        <span className="fw-semibold">
                          {deal.assigned_team?.team_name || "Not Assigned"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Assigned User</h6>
                  <div className="d-flex align-items-center mb-3">
                    <span
                      className="avatar avatar-sm border rounded-circle p-1 me-2"
                      style={{ borderRadius: "50%" }}
                    >
                      <img
                        src={deal.assigned_user?.avatar_url || male}
                        alt="Image"
                        style={{
                          width: "25px",
                          height: "25px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </span>
                    <p>{deal.assigned_user?.full_name ?? "Not Assigned"}</p>
                  </div>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Company</h6>
                  <div className="d-flex align-items-center">
                    <span
                      className="avatar avatar-sm border rounded-circle p-1 me-2"
                      style={{ borderRadius: "50%" }}
                    >
                      <img
                        src={deal.company?.avatar_url || company}
                        alt="Image"
                        style={{
                          borderRadius: "50%",
                        }}
                      />
                    </span>
                    <div
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                    >
                      <Link to={createCompanyUrl(deal)} target="_blank">
                        {deal.company?.company_name || "Not specified"}
                      </Link>
                    </div>
                  </div>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Contact</h6>
                  <div className="d-flex align-items-center mb-3">
                    <span
                      className="avatar avatar-sm border rounded-circle p-1 me-2"
                      style={{ borderRadius: "50%" }}
                    >
                      <img
                        src={deal.primary_contact?.avatar_url || male}
                        alt="Image"
                        style={{
                          width: "25px",
                          height: "25px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </span>
                    <Link
                      to={createContactUrl(deal)}
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                    >
                      {deal.primary_contact?.full_name || "Unassigned"}
                    </Link>
                  </div>
                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">Primary Phone</span>
                      <span className="col-6">
                        {deal.primary_contact?.primary_phone || "Not specified"}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Primary Email</span>
                      <span className="col-6">
                        {deal.primary_contact?.primary_email || "Not specified"}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Job Title</span>
                      <span className="col-6">
                        {deal.primary_contact?.job_title || "Not specified"}
                      </span>
                    </li>{" "}
                  </ul>{" "}
                  {/* Related Lead Section */}
                  {deal.realted_lead && (
                    <>
                      <hr />
                      <h6 className="mb-3 fw-semibold">
                        Related {getLifecycleTypeName("LEAD")}
                      </h6>{" "}
                      <div className="d-flex align-items-center">
                        {" "}
                        <div
                          className="avatar avatar-md flex-shrink-0 border p-2 bg-light"
                          style={{ borderRadius: "50%" }}
                        >
                          <i
                            className="ti ti-chart-arcs mt-2"
                            style={{ color: "#824eeb", fontSize: "1.5rem" }}
                          />
                        </div>
                        <div
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        >
                          <Link
                            to={createLeadUrl(deal)}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/leads/${deal.realted_lead?.lead_id}`, {
                                state: { leadData: deal.realted_lead },
                              });
                            }}
                          >
                            {deal.realted_lead.title && deal.realted_lead.title.length > 40 ? (
                              <Tooltip title={deal.realted_lead.title} placement="top" arrow>
                                <span className="d-block mb-1" style={{ cursor: "pointer" }}>
                                  {`${deal.realted_lead.title.substring(0, 40)}...`}
                                </span>
                              </Tooltip>
                            ) : (
                              <span className="d-block mb-1">{deal.realted_lead.title || `No Related ${getLifecycleTypeName("LEAD")}`}</span>
                            )}
                          </Link>
                        </div>
                      </div>
                    </>
                  )}
                  {/* Related Pipeline Section */}
                  {deal.related_pipeline && (
                    <>
                      {" "}
                      <hr />
                      <h6 className="mb-3 fw-semibold">
                        Related {getLifecycleTypeName("PIPELINE")}
                      </h6>
                      <div className="d-flex align-items-center">
                        <div
                          className="avatar avatar-md flex-shrink-0 border p-2 bg-light"
                          style={{ borderRadius: "50%" }}
                        >
                          <i
                            className="ti ti-timeline-event-exclamation mt-2"
                            style={{ color: "#824eeb", fontSize: "1.5rem" }}
                          />
                        </div>
                        <div
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        >
                          <Link
                            to={createPipelineUrl(deal)}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/pipelines/${deal.related_pipeline?.pipeline_id}`,
                                {
                                  state: {
                                    pipelineData: deal.related_pipeline,
                                  },
                                }
                              );
                            }}
                          >
                            {deal.related_pipeline.title && deal.related_pipeline.title.length > 40 ? (
                              <Tooltip title={deal.related_pipeline.title} placement="top" arrow>
                                <span className="d-block mb-1" style={{ cursor: "pointer" }}>
                                  {`${deal.related_pipeline.title.substring(0, 40)}...`}
                                </span>
                              </Tooltip>
                            ) : (
                              <span className="d-block mb-1">{deal.related_pipeline.title || `No Related ${getLifecycleTypeName("PIPELINE")}`}</span>
                            )}
                          </Link>
                        </div>
                      </div>
                    </>
                  )}
                  <hr />
                  <h6 className="mb-3 fw-semibold">Priority</h6>
                  <div className="priority-info">
                    <Select
                      options={priorityOptions}
                      value={
                        priorityOptions.find(
                          (option) => option.value === deal.priority
                        ) || null
                      }
                      onChange={(option) =>
                        handlePriorityUpdate(option?.value || "")
                      }
                      placeholder="Select priority"
                      isClearable={false}
                      isLoading={updatingPriority}
                      isDisabled={updatingPriority}
                      className="min-w-150"
                      formatOptionLabel={(option: any) => (
                        <div className="d-flex align-items-center">
                          {option.icon}
                          <span>{option.label}</span>
                        </div>
                      )}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minWidth: "150px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                  <hr />
                  {/* Tags Section */}

                  <>
                    <h6 className="mb-3 fw-semibold">Tags</h6>
                    <ul className="social-info">
                      <li style={{ padding: '5px' }}>
                        {
                          deal?.tags?.insert && Array.isArray(deal.tags.insert) && deal.tags.insert.length > 0 ? (
                            deal.tags.insert.map((tag: any, index: number) => (
                              <span key={tag.entity_tag_id || index}
                                className="badge me-1"
                                style={{
                                  backgroundColor: '#824EEB',
                                  color: 'white'
                                }}>
                                {tag.entity_tag_name}
                              </span>
                            ))
                          ) : (
                            <span className="text-muted">No Tags Assigned</span>
                          )
                        }
                      </li>
                    </ul>
                  </>
                  <hr />


                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">Created At</span>
                      <span className="col-6">
                        {formatCustomDateTime(deal.created_datetime)}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Created By</span>
                      <span className="col-6 d-flex align-items-center">
                        <span className="avatar avatar-xs me-1">
                          <img
                            src={deal.created_by?.avatar_url || male}
                            alt="Image"
                            style={{
                              width: "25px",
                              height: "20px",
                              borderRadius: "50%",
                            }}
                          />
                        </span>
                        <span>
                          {deal.created_by
                            ? `${deal.created_by.full_name}`
                            : "No User Found"}
                        </span>
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Last Modified</span>
                      <span className="col-6">
                        {formatCustomDateTime(deal.updated_datetime)}
                      </span>
                    </li>
                    <li className="row mb-0">
                      <span className="col-6">Modified By</span>
                      <span className="col-6 d-flex align-items-center">
                        <span className="avatar avatar-xs me-1">
                          <img
                            src={deal.updated_by?.avatar_url || male}
                            alt="Image"
                            style={{
                              width: "25px",
                              height: "20px",
                              borderRadius: "50%",
                            }}
                          />
                        </span>
                        {deal.updated_by
                          ? `${deal.updated_by.full_name}`
                          : "No User Found"}
                      </span>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
            {/* /Deal Sidebar */}
            {/* Deal Details */}
            <div className="col-xl-9">
              <div className="card mb-3">
                <div className="card-body pb-0">
                  <h4 className="fw-semibold mb-3">
                    {getLifecycleTypeName("DEAL")} LifeCycle Status
                  </h4>
                  {stagesLoading ? (
                    <div className="d-flex align-items-center justify-content-center py-3">
                      <div
                        className="spinner-border spinner-border-sm text-primary me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="text-muted">
                        Loading pipeline stages...
                      </span>
                    </div>
                  ) : lifecycleStages.length > 0 ? (
                    <div className="pipeline-list">
                      <ul>
                        {lifecycleStages.map((stage) => (
                          <li key={stage.lifecycle_type_stage_id}>
                            <Link
                              to="#"
                              className={
                                isStageActive(stage.lifecycle_type_stage_id)
                                  ? getStageColorByOrder(stage.stage_order)
                                  : "bg-gray"
                              }
                              style={{
                                pointerEvents: isStageActive(
                                  stage.lifecycle_type_stage_id
                                )
                                  ? "auto"
                                  : "none",
                                color: isStageActive(
                                  stage.lifecycle_type_stage_id
                                )
                                  ? ""
                                  : "#fff",
                              }}
                            >
                              {stage.stage_name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <div className="text-center py-3">
                      <span className="text-muted">
                        No pipeline stages found
                      </span>
                    </div>
                  )}{" "}
                  <Tabs showProductsServicesTab={true} showChatTab={true} />
                </div>
              </div>
              {/* Tab Content */}

              <div className="tab-content pt-0">
                {/* Activities */}
                <div className="tab-pane fade show active" id="activities">
                  <Activities
                    tenant_id={selectedTenantId}
                    related_entity_id={deal?.deal_id}
                    refreshTrigger={activitiesRefreshTrigger}
                    related_entity_name="deal"
                    crm_entity_id={deal?.crm_entity_id}
                  />
                </div>

                <Notes
                  tenant_id={selectedTenantId}
                  related_entity_id={deal?.deal_id}
                  related_entity_name="deal"
                  refreshTrigger={activitiesRefreshTrigger}
                  onActivityUpdate={() =>
                    setActivitiesRefreshTrigger((prev) => prev + 1)
                  }
                />

                <Files
                  tenant_id={selectedTenantId}
                  related_entity_id={deal?.deal_id}
                  related_entity_name="deal"
                  refreshTrigger={activitiesRefreshTrigger}
                />

                <Tasks
                  tenant_id={selectedTenantId}
                  related_entity_id={deal?.deal_id}
                  related_entity_name="deal"
                  refreshTrigger={activitiesRefreshTrigger}
                  onActivityUpdate={() =>
                    setActivitiesRefreshTrigger((prev) => prev + 1)
                  }
                />

                <ProductsServices
                  tenant_id={selectedTenantId}
                  related_entity_id={deal?.deal_id}
                  related_entity_name="deal"
                  onActivityUpdate={() =>
                    setActivitiesRefreshTrigger((prev) => prev + 1)
                  }
                  onEntityUpdate={refreshDealData}
                  currencyCode={deal?.currency_code}
                />

                <Email
                  contactIds={
                    deal?.primary_contact?.contact_id
                      ? [deal.primary_contact.contact_id]
                      : []
                  }
                />

                <Chat
                  tenant_id={selectedTenantId}
                  contact_id={deal?.primary_contact?.contact_id}
                  isContactPage={true}
                  lifecycleName="deal"
                />
              </div>
              {/* /Tab Content */}
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Delete Modal */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Delete Deal?</h4>
            <p className="mb-0">
              Are you sure you want to delete this deal? This action cannot be
              undone.
            </p>
            {deleteError && (
              <div className="alert alert-danger mt-3" role="alert">
                {deleteError}
              </div>
            )}
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-light me-2"
                onClick={handleDeleteCancel}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDeleteDeal}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Edit Deal Offcanvas */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvas_edit_deal"
        style={{ width: "550px" }}

      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit {getLifecycleTypeName("DEAL")}</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          {editError && (
            <div className="alert alert-danger" role="alert">
              {editError}
            </div>
          )}
          {isEditDealOpen && (
            <DealForm
              deal={deal}
              onSubmit={handleEditSubmit}
              onCancel={() => closeOffcanvas("offcanvas_edit_deal")}
              isMainApiCompleted={true}
              isSubmitting={isUpdating}
              onRefreshData={handleRefreshData}
            />
          )}
        </div>
      </div>

      {/* Create Contact */}
      <div
        className="modal custom-modal fade"
        id="create_contact"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-user-plus" />
                </div>
                <h3>Contact Created Successfully!!!</h3>
                <p>View the details of contact, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.deals} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Contact */}

      {/* Add Note */}
      <div
        className="modal custom-modal fade modal-padding"
        id="add_notes"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Notes</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="col-form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Note <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Attachment <span className="text-danger"> *</span>
                  </label>
                  <div className="drag-attach">
                    <input type="file" />
                    <div className="img-upload">
                      <i className="ti ti-file-broken" />
                      Upload File
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Uploaded Files</label>
                  <div className="upload-file">
                    <h6>Projectneonals teyys.xls</h6>
                    <p>4.25 MB</p>
                    <div className="progress">
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "25%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                    <p className="black-text">45%</p>
                  </div>
                  <div className="upload-file upload-list">
                    <div>
                      <h6>tes.txt</h6>
                      <p>4.25 MB</p>
                    </div>
                    <Link to="#" className="text-danger">
                      <i className="ti ti-trash-x" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-12 text-end modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    type="button"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Note */}

      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        defaultValue={""}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" /> Create a followup task
                      </label>
                    </div>
                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Call Log */}

      {/* Add File */}
      <div
        className="modal custom-modal fade custom-modal-two modal-padding"
        id="new_file"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New File</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-info-fieldset">
                <div className="add-details-wizard">
                  <ul className="progress-bar-wizard">
                    <li className="active">
                      <span>
                        <i className="ti ti-file" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Basic Info</h6>
                      </div>
                    </li>
                    <li>
                      <span>
                        <i className="ti ti-circle-plus" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Add Recipient</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <fieldset id="first-field-file">
                  <form>
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Choose Deal <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={dealsopen}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Document Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={documentType}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Owner <span className="text-danger">*</span>
                            </label>
                            <SelectWithImage2 />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Title <span className="text-danger"> *</span>
                            </label>
                            <input className="form-control" type="text" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Locale <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={LocaleData}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4>Signature</h4>
                            <ul className="nav sign-item">
                              <li className="nav-item">
                                <span
                                  className=" mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nosign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign1"
                                    name="email"
                                  />
                                  <label htmlFor="sign1">
                                    <span className="sign-title">
                                      No Signature
                                    </span>
                                    This document does not require a signature
                                    before acceptance.
                                  </label>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span
                                  className="active mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#use-esign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign2"
                                    name="email"
                                    defaultChecked
                                  />
                                  <label htmlFor="sign2">
                                    <span className="sign-title">
                                      Use e-signature
                                    </span>
                                    This document require e-signature before
                                    acceptance.
                                  </label>
                                </span>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className="tab-pane show active"
                                id="use-esign"
                              >
                                <div className="input-block mb-0">
                                  <label className="col-form-label">
                                    Document Signers{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="sign-content">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-3">
                                        <input
                                          className="form-control"
                                          type="text"
                                          placeholder="Enter Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="float-none mb-3 me-3 w-100">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email Address"
                                          />
                                        </div>
                                        <div className="input-btn mb-3">
                                          <Link to="#" className="add-sign">
                                            <i className="ti ti-circle-plus" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Content <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Add Content"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Reset
                          </button>
                          <button
                            className="btn btn-primary wizard-next-btn"
                            type="button"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
                <fieldset>
                  <form>
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4 className="mb-2">
                              Send the document to following signers
                            </h4>
                            <p>In order to send the document to the signers</p>
                            <div className="input-block mb-0">
                              <label className="col-form-label">
                                Recipients (Additional recipients)
                              </label>
                            </div>
                            <div className="sign-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="d-flex align-items-center">
                                    <div className="float-none mb-3 me-3 w-100">
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email Address"
                                      />
                                    </div>
                                    <div className="input-btn mb-3">
                                      <Link to="#" className="add-sign">
                                        <i className="ti ti-circle-plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Subject{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter Subject"
                            />
                          </div>
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Text{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Your document is ready"
                              defaultValue={""}
                            />
                          </div>
                          <button className="btn btn-light mb-3">
                            Send Now
                          </button>
                          <div className="send-success">
                            <p>
                              <i className="ti ti-circle-check" /> Document sent
                              successfully to the selected recipients
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            data-bs-dismiss="modal"
                          >
                            Save &amp; Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add File */}

      {/* Connect Account */}
      <div className="modal custom-modal fade" id="create_email" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Connect Account</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                  Account type <span className="text-danger"> *</span>
                </label>
                <Select
                  className="select2"
                  options={accountType}
                  placeholder="Choose"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="mb-3">
                <h5 className="form-title">Sync emails from</h5>
                <div className="sync-radio">
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test1"
                      name="radio-group"
                      defaultChecked
                    />
                    <label htmlFor="test1">Now</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test2"
                      name="radio-group"
                    />
                    <label htmlFor="test2">1 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test3"
                      name="radio-group"
                    />
                    <label htmlFor="test3">3 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test4"
                      name="radio-group"
                    />
                    <label htmlFor="test4">6 Month Ago</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-end modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button
                  className="btn btn-primary"
                  data-bs-target="#success_mail"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                >
                  Connect Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Connect Account */}

      {/* Success Contact */}
      <div className="modal custom-modal fade" id="success_mail" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-mail-opened" />
                </div>
                <h3>Email Connected Successfully!!!</h3>
                <p>
                  Email Account is configured with "example@example.com". Now
                  you can access email.
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-primary">
                    Go to email
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Success Contact */}

      {/* Add Contact */}
      <div className="modal custom-modal fade" id="add_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Contact</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-19.jpg"
                            alt=""
                          />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-20.jpg"
                            alt=""
                          />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt=""
                          />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt=""
                          />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-16.jpg"
                            alt=""
                          />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-22.jpg"
                            alt=""
                          />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Contact */}

      {/* Add Owner */}
      <div className="modal custom-modal fade" id="owner" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Deal Owner</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" defaultChecked />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-19.jpg"
                            alt=""
                          />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-20.jpg"
                            alt=""
                          />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt=""
                          />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt=""
                          />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-16.jpg"
                            alt=""
                          />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-22.jpg"
                            alt=""
                          />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Owner */}

      {/* Deal Status */}
      <div className="modal custom-modal fade" id="deal_status" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Deal Status</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    classNamePrefix="react-select"
                    options={status}
                    placeholder="Choose"
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={5}
                    defaultValue={""}
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Deal Status */}

      {/* Add New Pipeline */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvas_pipeline"
        style={{ width: "550px" }}
      >
        <div className="offcanvas-header border-bottom">
          <h4>Add New Pipeline</h4>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div>
              <div className="mb-3">
                <label className="col-form-label">
                  Pipeline Name <span className="text-danger">*</span>
                </label>
                <input className="form-control" type="text" />
              </div>
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Pipeline Stages</h5>
                  <Link
                    to="#"
                    className="add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage"
                  >
                    <i className="ti ti-square-rounded-plus" />
                    Add New
                  </Link>
                </div>
                <div className="pipeline-listing">
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Inpipeline
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link to="#" onClick={() => setOpenModal(true)}>
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Follow Up
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link to="#" onClick={() => setOpenModal(true)}>
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Schedule Service
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link to="#" onClick={() => setOpenModal(true)}>
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="form-title">Access</h5>
                <div className="d-flex flex-wrap access-item nav">
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="all"
                      name="status"
                      defaultChecked
                    />
                    <label htmlFor="all">All</label>
                  </div>
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#select-person"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="select"
                      name="status"
                    />
                    <label htmlFor="select">Select Person</label>
                  </div>
                </div>
                <div className="tab-content mb-3">
                  <div className="tab-pane fade" id="select-person">
                    <div className="access-wrapper">
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt="Image"
                          />
                          Vaughan
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt="Image"
                          />
                          Jessica
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#create_pipeline"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Pipeline */}

      {/* Add New Stage */}
      <div className="modal custom-modal fade" id="add_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New Stage */}

      {/* Create Pipeline */}
      <div
        className="modal custom-modal fade"
        id="create_pipeline"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-building" />
                </div>
                <h3>Pipeline Created Successfully!!!</h3>
                <p>View the details of pipeline, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.deals} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Pipeline*/}

      {/* Edit Stage */}
      <div className="modal custom-modal fade" id="edit_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Inpipeline"
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage */}

      {/* Compose Email Modal */}
      <ComposeEmail
        key={`compose-email-${composeOpenCounter}`}
        isOpen={isComposeEmailOpen}
        onClose={handleCloseComposeEmail}
        onMinimize={handleMinimizeComposeEmail}
        draftData={{
          send_to: getPrimaryEmail(),
          subject: `Re: ${deal?.title || "Deal"}`,
        }}
        readOnlyRecipient={false}
        crm_entity_id={deal?.crm_entity_id}
        record_id={deal?.deal_id}
      />

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvas_create_proposal"
        style={{ width: "550px" }}

      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Create {getLifecycleTypeName("PROPOSAL")}</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          {createProposalError && (
            <div className="alert alert-danger" role="alert">
              {createProposalError}
            </div>
          )}
          {isCreateProposalOpen && (
            <ProposalFormDataProvider isMainApiCompleted={true}>
              <ProposalForm
                key={`create-proposal-${resetProposalFormTrigger}`}
                onSubmit={handleCreateProposalSubmit}
                onCancel={handleCloseCreateProposal}
                isSubmitting={isCreatingProposal}
                resetTrigger={resetProposalFormTrigger}
                prefilledData={getPrefilledProposalData()}
                onRefreshList={handleRefreshData}
              />
            </ProposalFormDataProvider>
          )}
        </div>
      </div>

      <MarkStatusModal
        isVisible={showMarkStatusModal}
        onClose={() => setShowMarkStatusModal(false)}
        dealId={deal?.deal_id || 0}
        onSuccess={handleMarkStatusSuccess}
      />

      <SalesActivityModal
        isVisible={showSalesActivityModal}
        onClose={() => setShowSalesActivityModal(false)}
        crmEntityId={deal?.crm_entity_id}
        recordId={deal?.deal_id}
        onSuccess={() => setActivitiesRefreshTrigger((prev) => prev + 1)}
      />
    </>
  );
};

const DealsDetails = () => {
  const [isEditDealOpen, setIsEditDealOpen] = useState(false);

  return (
    <DealFormDataProvider isMainApiCompleted={true} shouldLoad={isEditDealOpen}>
      <DealDetailsContent
        isEditDealOpen={isEditDealOpen}
        setIsEditDealOpen={setIsEditDealOpen}
      />
    </DealFormDataProvider>
  );
};

export default DealsDetails;
